import { useState } from 'react';
import { CamhsConsent, CamhsConsentFormValues } from './CamhsConsent';
import { CareTeamChoice } from './CareTeamChoice';
import { CareTeamDetails, CareTeamDetailsFormValues } from './CareTeamDetails';
import { CamhsConsentFinish } from './CamhsConsentFinish';
import { createParentConsent } from '../../api/consent/consent';
import { CreateParentConsentPayload, RecipientType } from '../../api/consent/types';
import { selectFirstCamhsChild } from '../user/selectors';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { useHistory } from 'react-router-dom';
import { asyncPopulateUser } from '../user/slice';

export default function CamhsConsentRoute() {
    const [step, setStep] = useState(1);
    const [consent, setConsent] = useState<CamhsConsentFormValues>();
    const [careTeamChoice, setCareTeamChoice] = useState<RecipientType[]>([]);
    const [careTeamDetails, setCareTeamDetails] = useState<CareTeamDetailsFormValues>();

    const camhsChild = useAppSelector(selectFirstCamhsChild);

    const history = useHistory();
    const dispatch = useAppDispatch();

    if (!camhsChild) {
        history.push('/dashboard');
        return;
    }
    if (step === 1 && camhsChild.treatmentConsentGivenAt) {
        history.push('/dashboard');
        return;
    }

    switch (step) {
        case 1:
            return (
                <CamhsConsent
                    initialValues={consent}
                    childName={camhsChild.referralName}
                    onSubmit={(values) => {
                        setConsent(values);
                        setStep(2);
                    }}
                />
            );
        case 2:
            return (
                <div>
                    <CareTeamChoice
                        careTeamList={careTeamChoice}
                        childName={camhsChild.referralName}
                        onSubmit={(values) => {
                            setCareTeamChoice(values.careTeamList);
                            setStep(3);
                        }}
                        onBack={(values) => {
                            setCareTeamChoice(values.careTeamList);
                            setStep(1);
                        }}
                    />
                </div>
            );
        case 3:
            // This line is to prevent TS from complaining, but will never happen at this point.
            if (!careTeamChoice) return;
            return (
                <CareTeamDetails
                    initialValues={careTeamDetails}
                    childName={camhsChild.referralName}
                    careTeam={careTeamChoice}
                    onSubmit={async (values) => {
                        const payload: CreateParentConsentPayload = {
                            partnerCamhsChildId: camhsChild.partnerCamhsChildId,
                            consents: values.careTeam,
                        };
                        await createParentConsent(payload);
                        // Refresh user
                        dispatch(asyncPopulateUser());
                        setStep(4);
                    }}
                    onBack={(values) => {
                        setCareTeamDetails(values);
                        setStep(2);
                    }}
                />
            );
        case 4:
            return <CamhsConsentFinish childName={camhsChild.referralName} />;
    }
}
